import { InjectionToken } from '@angular/core';

export interface DocumentReader {
    read(lang: string, page: string): Promise<string>;
}

export const DOCUMENT_READER = new InjectionToken<DocumentReader>(
    'DOCUMENT_READER'
);